"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
export class BillInfoForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.taxpayer_number = "";
    this.taxpayer_number_special = "";
    this.title = "";
    this.title_special = "";
    this.invoice_deposit_bank = "";
    this.invoice_deposit_bank_special = "";
    this.invoice_account = "";
    this.invoice_account_special = "";
    this.invoice_addressandphone = "";
    this.invoice_email = "";
    this.invoice_email_invoice = "";
    this.consignee = "";
    this.consignee_special = "";
    this.phone = "";
    this.phone_special = "";
    this.type = "";
    this.invoice_phone = "";
    this.invoice_phone_special = "";
    this.invoice_address = "";
    // @UiFormAnnotations.Rule([
    //   {
    //     required: true,
    //     message: i18n.t("openbill.please_enter_invoice_address_special") as string,
    //     trigger: "blur",
    //   },
    // ])
    this.invoice_address_special = "";
    // @UiFormAnnotations.Rule([
    //   {
    //     required: true,
    //     message: i18n.t("openbill.please_enter_the_address") as string,
    //     trigger: "blur",
    //   },
    // ])
    this.address = "";
    this.official_seal = false;
    this.invoice_title = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "openbill.please_enter_taxpayer_identification_number"
      ),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "taxpayer_number", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "openbill.please_enter_taxpayer_identification_number"
      ),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "taxpayer_number_special", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_the_head_up"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "title", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_the_head_up"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "title_special", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_invoice_address_special"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "invoice_addressandphone", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_email"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "invoice_email", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_email"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "invoice_email_invoice", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "type", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("openbill.please_enter_the_head_up"),
      trigger: "blur"
    }
  ])
], BillInfoForm.prototype, "invoice_title", 2);
let OpenBill = class extends Vue {
  constructor() {
    super(...arguments);
    this.accessMode = "";
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new BillInfoForm();
    this.invoice_tax = 0;
    this.departmentId = "";
    this.order_amount = 0;
    this.currency = "CNY";
    this.only_special = false;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let guids = [];
        for (let item of this._items) {
          guids.push(item.guid);
        }
        let bill_request = {};
        if (this.controller.type === "ordinary") {
          bill_request = {
            taxpayerNumber: this.controller.taxpayer_number,
            title: this.controller.title,
            invoiceDepositBank: this.controller.invoice_deposit_bank,
            invoiceAccount: this.controller.invoice_account,
            invoicePhone: this.controller.invoice_phone,
            invoiceAddress: this.controller.invoice_address,
            invoiceEmail: this.controller.invoice_email,
            consignee: this.controller.consignee,
            phone: this.controller.phone,
            orderGuids: guids,
            type: this.controller.type
          };
        }
        if (this.controller.type === "special") {
          bill_request = {
            taxpayerNumber: this.controller.taxpayer_number_special,
            title: this.controller.title_special,
            invoiceDepositBank: this.controller.invoice_deposit_bank_special,
            invoiceAccount: this.controller.invoice_account_special,
            invoicePhone: this.controller.invoice_phone_special,
            invoiceAddress: this.controller.invoice_address_special,
            consignee: this.controller.consignee_special,
            phone: this.controller.phone_special,
            email: this.controller.invoice_email,
            orderGuids: guids,
            type: this.controller.type
          };
        }
        if (this.controller.type === "invoice") {
          bill_request = {
            title: this.controller.invoice_title,
            invoiceAddressAndPhone: this.controller.invoice_addressandphone,
            officialSeal: this.controller.official_seal,
            invoiceEmail: this.controller.invoice_email_invoice,
            orderGuids: guids,
            type: this.controller.type
          };
        }
        yield API.post(`api://base.auth.pro/v1/invoice-request`, bill_request);
        this.$message.success(
          this.$t("openbill.have_applied_for_invoicing")
        );
      } catch (error) {
        console.log("error", error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open() {
    return __async(this, null, function* () {
      try {
        let guids = [];
        console.log("this._items", this._items);
        for (let item of this._items) {
          guids.push(item.guid);
        }
        const response = yield API.get(`api://base.auth.pro/v1/invoice-requests-calculate`, {
          params: {
            orderIds: guids.join(",")
          }
        });
        const res = yield API.get(`api://base.auth/api/v7/accounts/info`);
        this.controller = new BillInfoForm();
        this.controller.taxpayer_number = res.data.invoice_taxpayer_number;
        this.controller.title = res.data.invoice_title;
        this.controller.invoice_deposit_bank = res.data.invoice_deposit_bank;
        this.controller.invoice_account = res.data.invoice_account;
        this.controller.invoice_phone = res.data.company_phone;
        this.controller.invoice_address = res.data.company_address;
        this.controller.invoice_email = res.data.invoice_email;
        this.controller.consignee = res.data.invoice_consignee;
        this.controller.phone = res.data.invoice_phone;
        this.controller.taxpayer_number_special = res.data.invoice_taxpayer_number;
        this.controller.title_special = res.data.invoice_title;
        this.controller.invoice_deposit_bank_special = res.data.invoice_deposit_bank;
        this.controller.invoice_account_special = res.data.invoice_account;
        this.controller.invoice_phone_special = res.data.company_phone;
        this.controller.invoice_address_special = res.data.company_address;
        this.controller.consignee_special = res.data.invoice_consignee;
        this.controller.phone_special = res.data.invoice_phone;
        this.controller.address = res.data.invoice_address;
        this.controller.invoice_title = res.data.invoice_title;
        this.controller.invoice_addressandphone = res.data.company_address;
        this.controller.invoice_email_invoice = res.data.invoice_email;
        this.currency = response.data.currency;
        if (this.currency === "USD") {
          this.controller.type = "invoice";
          this.only_special = true;
        } else {
          this.controller.type = "ordinary";
          this.only_special = false;
        }
        this.order_amount = response.data.orderAmount;
        this.invoice_tax = response.data.invoiceTax;
        this.dialog.visible = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  closeDepartmentDialog() {
    this.dialog.visible = false;
  }
};
__decorateClass([
  PropSync("items", {
    type: Array,
    default: function() {
      return [];
    }
  })
], OpenBill.prototype, "_items", 2);
OpenBill = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], OpenBill);
export {
  OpenBill as default
};
